import axios from 'axios';
import config from '../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../core/modules/common/tools/URLTools';

const apiFetchCarrierM39ComplianceDetails = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getCarrierM39ComplianceDetails',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchCarrierM39ComplianceDetails;
